import * as cnt from './constants';
import JSZip from 'jszip';
import JSZipUtils from 'jszip-utils';
import { saveAs } from 'file-saver';

export const updatePartnerDetails = payload => ({
  type: cnt.UPDATE_PARTNER_DETAILS,
  payload,
});

export const openMappingDialog = ({ index = null, mapping = {} } = {}) => ({
  type: cnt.OPEN_MAPPING_DIALOG,
  payload: { index, mapping },
});

export const closeMappingDialog = () => ({
  type: cnt.CLOSE_MAPPING_DIALOG,
});

export const updateMappingDialogField = ({ key, value }) => ({
  type: cnt.UPDATE_MAPPING_DIALOG_FIELD,
  payload: { key, value },
});

export const saveMappingDialog = () => ({
  type: cnt.SAVE_MAPPING_DIALOG,
});

export const addFileToContractFromMessage = () => ({});

export const unassocSingleActivity = ({ messageId }) => ({
  type: cnt.UNASSOC_A_MESSAGE,
  payload: { messageId }
});

export const bulkDownloadS3File = (files, zipName) => {
  // IMPORTANT: file.path here does not include s3 url and s3bucket
  const zip = new JSZip();
  let count = 0;
  files.forEach((file, fileIndex) => {
    JSZipUtils.getBinaryContent(
      `${process.env.REACT_APP_OLD_APP_URL}/proxy/s3/file?key=${file.path ||
        file.url}`,
      (err, data) => {
        if (!err)
          zip.file(`${fileIndex + 1}-${file.name || file.fileName}`, data, {
            binary: true
          });
        count++;
        if (count === files.length) {
          zip.generateAsync({ type: 'blob' }).then(content => {
            saveAs(content, `${zipName || 'TCFiles'}.zip`);
          });
        }
      }
    );
  });
};

export const downloadFromUrl = file => {
  // return window.open(`${apiUrl}/s3/file?key=${path}`);
  var a = document.createElement('a');
  a.download = file.fileName || file.name || '';
  a.target = '_blank';
  a.setAttribute('download', file.fileName || file.name);
  a.href = `${process.env.REACT_APP_OLD_APP_URL}/proxy/s3/file?key=${file.url ||
    file.path}&fileName=${file.fileName || file.name}`;
  // firefox doesn't support `a.click()`...
  a.dispatchEvent(new MouseEvent('click'));
};
